/* ─────────────────────────────────────────────────────────────
   WidgetTicketsAreas.jsx — H3.
   Bandeja inline de tickets RPA-* para sup_general_pipas, capturista y admin.
   No renderiza nada si rol no autorizado o si no hay tickets abiertos.
   ───────────────────────────────────────────────────────────── */
import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../auth/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ROLES_VEN = ["admin", "supervisor_general_pipas", "capturista"];

const URG_COLOR = {
  ALTA:  { bg: "#FEE2E2", color: "#B91C1C" },
  MEDIA: { bg: "#FEF3C7", color: "#B45309" },
  BAJA:  { bg: "#DCFCE7", color: "#15803D" },
};

const CAT_LABEL = {
  TUBERIA_ROTA: "Tubería rota",
  SIN_PRESION:  "Sin presión",
  BOMBA_DANADA: "Bomba dañada",
  FUGA:         "Fuga",
  VANDALISMO:   "Vandalismo",
  OTRO:         "Otro",
};

export default function WidgetTicketsAreas() {
  const { user } = useAuth();
  const [contador, setContador] = useState(null);
  const [abierto, setAbierto] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);

  const autorizado = ROLES_VEN.includes(user?.rol);

  useEffect(() => {
    if (!autorizado) return;
    axios.get(`${API}/tickets-areas/contador`)
      .then(r => setContador(r.data.abiertos))
      .catch(() => setContador(null));
  }, [autorizado]);

  useEffect(() => {
    if (!abierto) return;
    setLoading(true);
    setTickets([]);
    axios.get(`${API}/tickets-areas?estado=ABIERTO&limit=20`)
      .then(r => setTickets(r.data.tickets || []))
      .finally(() => setLoading(false));
  }, [abierto]);

  if (!autorizado || contador === null || contador === 0) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setAbierto(true)}
        className="card-base wta-card"
        data-testid="widget-tickets-areas"
      >
        <div className="wta-icon"><i className="fa-solid fa-ticket"/></div>
        <div className="wta-text">
          <div className="wta-count" data-testid="widget-tickets-count">{contador}</div>
          <div className="wta-label">
            {contador === 1 ? "reporte de áreas abierto" : "reportes de áreas abiertos"}
          </div>
        </div>
        <i className="fa-solid fa-chevron-right wta-chev"/>
      </button>

      {abierto && (
        <div className="wta-bg" onClick={() => setAbierto(false)} data-testid="widget-tickets-drawer">
          <div className="wta-drawer" onClick={(e) => e.stopPropagation()}>
            <header className="wta-head">
              <div>
                <h3 className="wta-title"><i className="fa-solid fa-ticket mr-2"/>Reportes de áreas abiertos</h3>
                <p className="wta-sub">{tickets.length} {tickets.length === 1 ? "ticket pendiente" : "tickets pendientes"} de atención</p>
              </div>
              <button
                type="button"
                onClick={() => setAbierto(false)}
                className="mp-x"
                aria-label="Cerrar"
                data-testid="widget-tickets-close"
              ><i className="fa-solid fa-xmark"/></button>
            </header>
            <div className="wta-body">
              {loading && <div className="text-center py-6 text-sm text-slate-500">Cargando…</div>}
              {!loading && tickets.length === 0 && (
                <div className="text-center py-8 text-sm text-slate-500">Sin tickets abiertos.</div>
              )}
              {!loading && tickets.map(t => {
                const urg = URG_COLOR[t.urgencia] || URG_COLOR.MEDIA;
                return (
                  <article key={t.id} className="wta-item" data-testid={`widget-ticket-${t.folio}`}>
                    <div className="wta-item-head">
                      <span className="mono wta-folio">{t.folio}</span>
                      <span className="pill-tiny" style={{background: urg.bg, color: urg.color, fontWeight: 700}}>{t.urgencia}</span>
                    </div>
                    <div className="wta-item-titulo">{t.espacio_nombre || t.espacio_id_oficial}</div>
                    <div className="wta-item-meta">
                      <span className="pill-tiny pill-zone">{t.zona_id}</span>
                      <span>{CAT_LABEL[t.categoria] || t.categoria}</span>
                      <span>·</span>
                      <span>por {t.reportado_por_nombre}</span>
                    </div>
                    {t.descripcion && <p className="wta-item-desc">{t.descripcion}</p>}
                  </article>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
